
import { Vue, Component, Prop } from 'vue-property-decorator'
import { uploadFileInEdit, handleEditFilter } from '@/api/seTel'
import { Upload } from 'element-ui'
import { IEditTaskData } from '@/@types/global'
@Component({
  name: 'EditForm'
})
export default class EditForm extends Vue {
  @Prop() editFormData!: any
  fileList = []
  statusList = [
    { label: '未开始', value: 0 },
    { label: '进行中', value: 1 },
    { label: '已完成', value: 2 },
    { label: '已关闭', value: -1 }
    ]
  showRemoteID = false
  submitData: IEditTaskData = {
    Code: '',
    Title: '',
    NumberTypeName: '',
    OkQuantity: '',
    CompletedQuantity: '',
    Quantity: '',
    Status: '',
    Remarks: '',
    id: '',
    OriginFilePath: '',
    fileCount: '',
    okCount: '',
	RemoteID: '',
	ExtFields: null,
	ChangeTypeID: 0
  }
  initDialog(row: any) {
    this.submitData = {
      Code: row.Code,
      Title: row.Title,
      NumberTypeName: row.NumberTypeName,
      OkQuantity: row.OkQuantity,
      CompletedQuantity: row.CompletedQuantity,
      Quantity: row.Quantity,
      Status: row.Status,
      Remarks: row.Remarks,
      id: row.ID,
      OriginFilePath: row.OriginFilePath,
      fileCount: '',
    okCount: '',
    RemoteID: row.RemoteID,
    ChangeTypeID: row.ChangeTypeID
    }
  }
  // 上传
  handleBeforeUpload(file: File) {
    // 上传的文件校验
    const { name } = file
    if (!name.endsWith('.txt') && !name.endsWith('.csv')) {
      this.$message.error('请上传txt或csv格式文件')
      return false
    }
  }
  handleUpload(e: any) {
    // 自定义上传逻辑
    const { file } = e
    const formData = new FormData()
    formData.append('file', file)
    formData.append('id', this.submitData.id)
    uploadFileInEdit(formData)
      .then((res: any) => {
        this.$message.success('上传成功！')
        this.submitData.OriginFilePath = res.path
        this.submitData.fileCount = res.fileCount
        this.submitData.okCount = res.okCount
        this.submitData.OkQuantity = res.fileCount
      })
      .catch(err => {
        this.$message.error(err.msg)
        const uploadRef = this.$refs.uploadRef as Upload
        uploadRef.clearFiles()
      })
  }

  handleSave() {
    const data = {
      ID: this.submitData.id,
      Quantity: this.submitData.Quantity,
      OkQuantity: this.submitData.OkQuantity,
      CompletedQuantity: this.submitData.CompletedQuantity,
      FilePath: this.submitData.OriginFilePath,
      Remarks: this.submitData.Remarks,
      Status: this.submitData.Status,
      RemoteID: this.submitData.RemoteID,
      ChangeTypeID: this.submitData.ChangeTypeID
    }
    handleEditFilter(data).then(() => {
      this.$message.success('修改成功')
      this.$emit('editSuccess')
    })
  }
}
